(function() {
    angular
        .module('app')
        .factory('batchselect2AltService', batchSelect2AltService);

    batchSelect2AltService.$inject = ['$rootScope', '$timeout', '$q', '$http'];

    function batchSelect2AltService($rootScope, $timeout, $q, $http) {
        var pendingIds = [];  // Lista para almacenar los objetos de las IDs recibidas
        var pendingDeferreds = [];  // Lista para almacenar las promesas asociadas a cada obj
        var currentRequestInProgress = false;  // Flag para saber si hay una petición en curso
        var timeoutPromise = null;  // Promesa de timeout para la petición final

        // Función para realizar la petición agrupada
        function requestBatch(objReq) {
            return $http.get('/backend/altcrm/content/getvalueselect2lote', { ignoreLoadingBar:true,params: { objReq: JSON.stringify(objReq) } });
        }

        // Función para agregar un objeto (ID u otro valor) a la lista y controlar el batch
        function addId(obj) {
            var deferred = $q.defer();

            // Agregar el objeto a la lista de pendientes
            pendingIds.push(obj);
            pendingDeferreds.push(deferred);  // Guardamos también la promesa de esta ID

            // Si no hay un timeout en curso, configuramos uno
            if (!timeoutPromise) {
                timeoutPromise = $timeout(function() {
                    if (!currentRequestInProgress) {
                        var currentObj = pendingIds.slice();  // Hacemos una copia de los objetos actuales
                        var currentDeferreds = pendingDeferreds.slice();  // Copiamos las promesas actuales

                        // Limpiamos la lista para el siguiente lote
                        pendingIds = [];
                        pendingDeferreds = [];
                        currentRequestInProgress = true;  // Marcamos que hay una petición en curso

                        requestBatch(currentObj).then(function(response) {
                            // Resolver todas las promesas pendientes con los datos recibidos
                            currentDeferreds.forEach(function(deferred) {
                                deferred.resolve(response.data);
                            });
                        }).catch(function(error) {
                            // Rechazar todas las promesas en caso de error
                            currentDeferreds.forEach(function(deferred) {
                                deferred.reject(error);
                            });
                        }).finally(function() {
                            currentRequestInProgress = false;  // Petición completada
                            timeoutPromise = null;  // Limpiar el timeout
                        });
                    } else {
                        // Si ya hay una petición en curso, no hacemos nada, simplemente limpiamos el timeout
                        timeoutPromise = null;
                    }
                }, 500);  // Tiempo de espera para acumular más objetos
            }

            return deferred.promise;
        }

        return {
            addId: addId
        };
    }
})();